
<template>
    <div>
        <vxe-modal width="80vw" height="600" :title="dialogtitle" v-model="dialogprodVegaVisible" destroy-on-close show-zoom
            resize transfer draggable v-loading="isLoading">


            <div :id="vegaid" v-show="!no_data"> </div>

            <div v-show="no_data" class="no-data">
                <div>暂时无可用的智囊，如需帮助请联系客户经理。</div>
            </div>
            <div id="tip-vega" class="vg-tooltip" hidden="true"></div>
        </vxe-modal>
        <vxe-modal title="订阅" width="600" height="400" v-model="dialogshareVisible" destroy-on-close show-zoom>
            <div class="divqrcode">
                    <vue-qr v-if="createQ" ref="vueqr" :text="shareUrl" :size="250" :logoSrc="logo"
                        :logoScale="0.2"></vue-qr>
                    <div class="sharedesc">{{ prodName }}</div>
                </div>
        </vxe-modal>
    </div>
</template>

<script>
import * as vega from "vega";
import apiAxios from "@/config/apiAxios";
import CryptoJS from 'crypto-js/index';
import logo from '@/assets/img/favicon.png';
export default {
    name: "dialogprodVega",
    components: {},
    props: {},
    data() {
        return {
            logo:logo,
            dialogtitle: "",
            vegaid: "prodVega",
            dialogprodVegaVisible: false,
            no_data: false,
            vegaDefaultConfig: {
                "$schema": "https://vega.github.io/schema/vega/v5.json",
                "width": document.body.clientWidth*0.8,
                "height": 500,

                "padding": 0,
                "autosize": "fit",
                "signals": [
                    { "name": "cx", "update": "width / 2" },
                    { "name": "cy", "update": "height / 2" },
                    {
                        "name": "gravityX",
                        "value": 0.1
                    },
                    {
                        "name": "gravityY",
                        "value": 0.5
                    }
                ],
                "data": [
                    {
                        "name": "table",
                        "values": []
                    }
                ],
                "scales": [
                    {
                        "name": "size",
                        "domain": { "data": "table", "field": "amount" },
                        "range": [100, 3000]
                    },
                    {
                        "name": "color",
                        "type": "ordinal",
                        "domain": { "data": "table", "field": "category" },
                        "range": []
                    }
                ],
                "marks": [
                    {
                        "name": "nodes",
                        "type": "symbol",
                        "from": { "data": "table" },
                        "encode": {
                            "enter": {

                                "fill": { "signal": "datum.fillSymbol" },

                                "xfocus": { "signal": "cx" },
                                "yfocus": { "signal": "cy" },
                                "cursor": { "value": "pointer" }
                            },
                            "update": {
                                "size": { "signal": "pow(2 * datum.amount, 2)", "scale": "size" },

                                "angle": { "value": 245 },
                                "strokeWidth": { "value": 20 },
                                "strokeOpacity": { "value": 0 },
                                "fillOpacity": { "value": 1 },
                                "tooltip": { "signal": "datum" }
                            }
                        },
                        "transform": [
                            {
                                "type": "force",
                                "iterations": 100,
                                "static": false,
                                "forces": [
                                    {
                                        "force": "collide",
                                        "iterations": 3,
                                        "radius": { "expr": "sqrt(datum.size)/2+5" }
                                    },
                                    { "force": "center", "x": { "signal": "cx" }, "y": { "signal": "cy" } },
                                    { "force": "x", "x": "xfocus", "strength": { "signal": "gravityX" } },
                                    { "force": "y", "y": "yfocus", "strength": { "signal": "gravityY" } }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "text",
                        "from": { "data": "nodes" },
                        "encode": {
                            "enter": {
                                "dx": { "value": 0 },
                                "align": { "value": "center" },
                                "baseline": { "value": "alphabetic" },
                                "fontSize": { "signal": "if(datum.datum.amount>=1,14,12)" },

                                "fontWeight": { "value": "bold" },
                                "fill": { "value": "white" },
                                "text": { "signal": "[slice(datum.datum.category,0,4),slice(datum.datum.category,4)]" },
                                "limit": { "value": 70 },
                                "cursor": { "value": "pointer" }
                            },
                            "update": { "x": { "field": "x" }, "y": { "field": "y" }, "tooltip": { "signal": "datum" } }
                        }
                    }
                ]
            },
            tags: [],
            toolBoxList: [],
            isLoading: false,
            formData: {
                isfree: "0", // 收费收费，0免费，1收费
                isusedBytotal: true, // 是否按使用次数
                usedBytotal: 10, // 使用次数
                everyprice: '',// 按次收费价格
                isusedBytime: false,
                endtime: '',
                timeprice: '', // 按时间收费价格
                isforever: true,
                foreverprice: '',// 永久价格
                isshare: '1',// 能否继续分享，0 不能，1 能
            },
            createQ:false,
            dialogshareVisible:false,
            prodName:"",
            shareUrl:"",
        }
    },
    methods: {
        getTableData(tags, dialogtitle) {
            this.dialogtitle = dialogtitle;
            this.dialogprodVegaVisible = true;
            this.isLoading = true;
            let tagsDefault = ["tech_sbom"];
            let paratags = tagsDefault.concat(tags)
            let params = {
                //   "userId": this.userInfo._id,  //可以不用传，接口会自动增加uid参数
                "tags": paratags,
               // "userId":"genesys_app",
                "filter": "'fileInfo.extends.resource.delStatus' eq 1  and 'fileInfo.extends.resource.type' eq '1'",
                prodType: "prod_tpl_szzk"
            }
            this.no_data=false;
            apiAxios.apmSyncPost('tool_box_list_00001', params, {}, _res => {
                this.isLoading = false;
                if (_res.code == 200) {
                    let data = _res.data.data || [];
                    if (data.length <= 0) {
                        this.no_data = true;
                        return;
                    }
                    this.toolBoxList = data;
                    this.vegaInit();
                } else {
                    this.$message.error(`获取${dialogtitle}数据出错`);

                }
            })
        },
        vegaInit() {
            let dataArr = []
            this.toolBoxList.forEach(item => {
                item.category = item.name;
                item.tags = item.tags || {};
                if (item.tags["tech_dev"]) {
                    item.amount = 0.6;
                } else {
                    item.amount = 1;
                }
                item.fillSymbol = {
                    "gradient": "linear",
                    "x1": 0,
                    "y1": 0,
                    "x2": 1,
                    "y2": 1,
                    "stops": [
                        {
                            "offset": 0,
                            "color": "#fff"
                        },
                        {
                            "offset": 1,
                            "color": "rgb(157,87,94)"
                        }
                    ]

                }
                if (item.tags["scene_oppty"]) {//商机发现,黄色
                    if (item.tags["tech_dev"]) {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#ffffff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(230,177,105)"
                            }

                        ]
                    } else {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#fff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(154,120,72)"
                            }

                        ]
                    }
                    dataArr.push(item);
                } else if (item.tags["scene_value"]) {//价值判断,绿色
                    if (item.tags["tech_dev"]) {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#fff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(108,190,173)"

                            }
                        ]
                    } else {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#fff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(73,130,119)"
                            }
                        ]
                    }
                    dataArr.push(item);
                } else if (item.tags["scene_profession"]) {//专业操作,蓝色
                    if (item.tags["tech_dev"]) {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#fff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(108,172,190)"

                            }
                        ]
                    } else {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#fff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(83,123,134)"
                            }
                        ]
                    }

                    dataArr.push(item);
                } else if (item.tags["scene_warning"]) {//风险预警,红色
                    if (item.tags["tech_dev"]) {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#fff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(206,135,142)"

                            }
                        ]
                    } else {
                        item.fillSymbol.stops = [
                            {
                                "offset": 0,
                                "color": "#fff"
                            },
                            {
                                "offset": 1,
                                "color": "rgb(157,87,94)"
                            }
                        ]
                    }
                    dataArr.push(item);
                }

            });
            this.vegaDefaultConfig.data[0].values = dataArr;
            let that = this;
            //  this.dialogprodVegaVisible = true;
            this.$nextTick(() => {
                var view = new vega.View(vega.parse(that.vegaDefaultConfig))
                    .renderer("svg")
                    .initialize("#" + that.vegaid)
                    .hover()
                    .run();
                view.tooltip((handler, event, item, value) => {
                    let el = document.getElementById('tip-vega');
                    if (!el) {
                        el = document.createElement('div');
                        el.setAttribute('id', 'tip-vega');
                        el.classList.add('vg-tooltip');
                        document.body.appendChild(el);
                    }
                    // 移开隐藏
                    if (event.vegaType == 'mouseout') {
                        el.hidden = true;
                        return
                    }
                    el.hidden = false;
                    let configData = {};
                    //console.log(item);
                    if (item && item.text) {
                        configData = item.datum.datum;
                    } else if (item && item.datum) {
                        configData = item.datum;
                    }
                    let html = "<div>点击订阅</div>";
                    let offsety = 130;
                    if (configData.tips == null) {
                        html += `<span>产品名称：</span><span>${configData.category}</span>`
                    } else {
                        let tips = configData.tips.formData;
                        let formdata = [];
                        for (let k in tips) {
                            formdata.push(tips[k])
                        }
                        formdata.map(function (d) {
                            html += `<div><span>${d.label}：</span>${d.value}</div>`
                        });
                        html += `<div><span>作者：</span><span>${configData.author}</span></div>`;
                        html += `<div><span>时间：</span><span>${configData.ctime}</span></div>`
                            ;
                    }
                    el.innerHTML = html;
                    let st = document.body.scrollTop || document.documentElement.scrollTop;
                    let sl = document.body.scrollLeft || document.documentElement.scrollLeft;
                    let left = event.clientX;
                    let top = event.clientY;
                    let layerX = event.layerX
                    let layerY = event.layerY;
                    el.style.left = layerX + 'px';
                    el.style.top = layerY + 'px';
                    // el.style.left = (left) + sl + 'px';
                    // el.style.top = (top - offsety) + st + 'px';

                });

                view.addEventListener('click', function (event, item) {
                    if (!item) {
                        return;
                    }
                    that.createQrcode(item.datum)
                })
                view.addEventListener('touchstart', function (event, item) {
                    if (!item) {
                        return;
                    }
                    that.createQrcode(item.datum)
                })

            })

        },
        createQrcode(item) {
            console.log(item);
            this.createQ = false;
            this.prodName=item.name;
            let _param = {
                token: sessionStorage.getItem('USER_TOKEN_VAL'), 
                sourceUid:"genesys_app",
                fid: [item.fid],
                formData: this.getformParam(),
                destDirPath:"usys/products/release",//目标用户目录路径，要复制到此目录
                sourceDirPath:"usys/products/release" //目标目录路径
            }
            apiAxios.apmSyncPost("api000126", _param,{}, res => {
               
                if (res.code == '200') {
                    let _path = CryptoJS.enc.Base64.stringify(
                            CryptoJS.enc.Utf8.parse(JSON.stringify({ fid: res.data.fid, ruleId: "copy_to_userB_00001" }))
                        );
                        let redirect_uri = encodeURIComponent(`${config.ssoUrl}/wechatPub/webAuth?p=${_path}`);
                        let _url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.wxAppId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${config.shareStatus}#wechat_redirect`

                        this.shareUrl = _url;
                        this.createQ = true;
                        this.dialogshareVisible=true;
                      //  this.finishedQr = true;
                   // this.getApmTask(res.data.taskId, '')
                } else {

                    this.$notify({ type: 'danger', message: '生成失败' })
                }
            })
         

        },

         // 对分享参数formData参数处理
         getformParam() {
            let obj = {}
            // 处理,免费
            if (this.formData.isfree == 0) {

                // 是否永久，是永久别的设置将失效
                if (this.formData.isforever) {
                    obj.isforever = this.formData.isforever;
                    obj.isusedBytotal = false;
                    obj.isusedBytime = false;
                } else {
                    obj.isforever = false;
                    obj.isusedBytotal = this.formData.isusedBytotal;
                    obj.isusedBytime = this.formData.isusedBytime;
                    if (this.formData.isusedBytotal) {

                        obj.usedBytotal = this.formData.usedBytotal;
                    }
                    if (this.formData.isusedBytime) {

                        obj.endtime = this.formData.endtime;
                    }

                }
            } else {
                // 是否永久，是永久别的设置将失效
                if (this.formData.isforever) {
                    obj.isusedBytotal = false;
                    obj.isusedBytime = false;
                    obj.isforever = this.formData.isforever;
                    obj.foreverprice = this.formData.foreverprice
                } else {
                    obj.isforever = false;
                    obj.isusedBytotal = this.formData.isusedBytotal;
                    obj.isusedBytime = this.formData.isusedBytime;
                    if (this.formData.isusedBytotal) {

                        obj.usedBytotal = this.formData.usedBytotal;
                        obj.everyprice = this.formData.everyprice;
                    }
                    if (this.formData.isusedBytime) {

                        obj.endtime = this.formData.endtime;
                        obj.timeprice = this.formData.timeprice;
                    }

                }

            }
            obj.isfree = this.formData.isfree;
            obj.isshare = this.formData.isshare;

            return obj;
        }


    },
    mounted() {

        // var view = new vega.View(vega.parse(this.vegaDefaultConfig))
        // .renderer("svg")
        // .initialize("#"+this.vegaid)
        // .hover()
        // .run();

    },
    created() {

    }

}
</script>

<style lang="less" scoped>
#tip-vega {
    position: absolute;
    background-color: rgba(255, 255, 255, .5);
    border: 1px solid rgb(189, 186, 186);
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 12px;
    text-align: left;
    max-width: 300px;
    min-width: 100px;
}

.no-data {
    text-align: center;
    position: absolute;
    left: 40%;
    bottom: 20%;
    color: gray;
}
.divqrcode {
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // background-color: rgb(246, 248, 250);
    // flex-wrap: wrap;

    // img {
    //     flex-grow: 1;
    // }
    text-align: center;
    .sharedesc {
        flex-grow: 1;
        text-align: center;
        font-size: 12px;
        color: #aca1a1
    }
  
}
</style>

